import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import translationEN from './translations/en/index';
import translationFR from './translations/fr/index';
import translationES from './translations/es/index';
import translationIT from './translations/it/index';
import translationPL from './translations/pl/index';
import translationPT from './translations/pt/index';

// the translations
// (tip move them in a JSON file and import them)
const resources = {
  fr: translationFR,
  en: translationEN,
  es: translationES,
  pt: translationPT,
  pl: translationPL,
  it: translationIT
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    ns: ['app', 'common', 'form', 'glossary', 'validation'],
    defaultNS: 'app',
    lng: 'fr',

    // keySeparator: false, // we do not use keys in form messages.welcome

    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

export default i18n;
